import React, { useEffect } from 'react';
import { dspTimeout } from 'fmc-sdk';
import DspExpiredView from './DspExpiredView';

import useFeature from 'hooks/useFeature';
import useFmcHost from 'hooks/useFmcHost';
import { useDispatch } from 'react-redux';
import { resetInstantCredit } from 'state/resetInstantCredit';
import useRouter from 'use-react-router';

const DspExpired: React.FC = props => {
  const { isEnabled } = useFeature();
  const fmcDispatch = useFmcHost();
  const dispatch = useDispatch();

  interface Location {
    location: {
      state: {
        accountIndex: string | undefined;
        cardType: string | undefined;
      };
    };
  }
  const {
    location: {
      state: { accountIndex, cardType },
    },
  }: Location = useRouter();
  useEffect(() => {
    dispatch(resetInstantCredit());
  }, [dispatch]);

  useEffect(() => {
    fmcDispatch(dspTimeout());
  }, [fmcDispatch]);

  return (
    <DspExpiredView
      {...props}
      canRetrieveDsp={isEnabled('dspRetrieval')}
      accountIndex={accountIndex}
      cardType={cardType}
    />
  );
};

export default DspExpired;
